import React from 'react';
import ValueBadges from './ValueBadges';
import { pct, fmt } from '../data';

export default function WatchCard({ watch, onClick }) {
  const premium = watch.market > watch.msrp;

  return (
    <div onClick={onClick} style={{
      background: 'var(--surface)', border: '0.5px solid var(--border)',
      borderRadius: 'var(--radius-lg)', padding: '18px', cursor: 'pointer',
      transition: 'border-color 0.15s, box-shadow 0.15s, transform 0.15s',
      display: 'flex', flexDirection: 'column', gap: 8, position: 'relative',
    }}
      onMouseEnter={e => { e.currentTarget.style.borderColor='var(--border2)'; e.currentTarget.style.boxShadow='0 8px 32px rgba(0,0,0,0.08)'; e.currentTarget.style.transform='translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none'; }}
    >
      {/* In production badge */}
      {watch.inProduction && (
        <div style={{
          position: 'absolute', top: 14, right: 14,
          display: 'flex', alignItems: 'center', gap: 4,
          fontSize: 9, fontWeight: 700, letterSpacing: '0.07em',
          color: '#0f9b6e', background: 'rgba(15,155,110,0.1)',
          border: '0.5px solid rgba(15,155,110,0.3)',
          padding: '3px 7px', borderRadius: 99,
          fontFamily: "'Space Mono', monospace",
        }}>
          <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#0f9b6e', display: 'inline-block', animation: 'pulse 2s ease-in-out infinite' }} />
          IN PRODUCTION
        </div>
      )}

      {/* Brand */}
      <div style={{ fontSize: 10, color: 'var(--text3)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', fontFamily: "'Space Mono', monospace", paddingRight: watch.inProduction ? 110 : 0 }}>
        {watch.brand}
      </div>

      {/* Model + nickname */}
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.25, fontFamily: "'Space Grotesk', sans-serif", marginBottom: watch.nickname ? 4 : 0 }}>
          {watch.model}
        </div>
        {watch.nickname && (
          <span style={{
            fontSize: 11, fontWeight: 700, color: '#C0392B',
            background: 'rgba(192,57,43,0.08)', padding: '2px 8px',
            borderRadius: 5, fontFamily: "'Space Grotesk', sans-serif",
          }}>"{watch.nickname}"</span>
        )}
      </div>

      {/* ── PRICE — most prominent element ── */}
      <div style={{
        display: 'flex', alignItems: 'baseline', gap: 10,
        padding: '10px 0', borderTop: '0.5px solid var(--border)', borderBottom: '0.5px solid var(--border)',
        marginTop: 2,
      }}>
        <span style={{
          fontSize: 24, fontWeight: 700, color: 'var(--text)',
          fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.02em',
        }}>
          {fmt(watch.market)}
        </span>
        <span style={{
          fontSize: 11, fontWeight: 600,
          color: premium ? 'var(--up)' : 'var(--dn)',
          fontFamily: "'Space Mono', monospace",
          background: premium ? 'rgba(15,155,110,0.08)' : 'rgba(201,79,40,0.08)',
          padding: '2px 6px', borderRadius: 5,
        }}>
          {pct(watch.market, watch.msrp)} retail
        </span>
      </div>

      {/* Colorway */}
      {watch.colorway && (
        <div style={{ fontSize: 11, color: 'var(--text2)', lineHeight: 1.5, fontFamily: "'Space Grotesk', sans-serif" }}>
          {watch.colorway.length > 60 ? watch.colorway.slice(0, 60) + '…' : watch.colorway}
        </div>
      )}

      {/* Ref + year */}
      <div style={{ fontSize: 10, color: 'var(--text3)', fontFamily: "'Space Mono', monospace", letterSpacing: '0.04em' }}>
        Ref. {watch.ref} · {watch.year} · {watch.condition}
      </div>

      {/* Tags */}
      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        {watch.tags.slice(0, 3).map(t => (
          <span key={t} style={{
            fontSize: 10, padding: '2px 7px', borderRadius: 99,
            border: '0.5px solid var(--border2)', color: 'var(--text3)',
            fontFamily: "'Space Grotesk', sans-serif",
          }}>{t}</span>
        ))}
      </div>

      {/* Footer */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 2 }}>
        <span style={{ fontSize: 10, color: 'var(--text3)', fontFamily: "'Space Mono', monospace" }}>
          MSRP {fmt(watch.msrp)}
        </span>
        <span style={{ fontSize: 12, color: 'var(--text2)', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 500 }}>
          View details <i className="ti ti-arrow-right" style={{ fontSize: 11 }} />
        </span>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.8); }
        }
      `}</style>
    </div>
  );
}
